import { GetTagInfoList } from '@/epp/expertmain/experttag/api/TagApi'

/**
 * 获取所有的标签列表
 * @returns {Promise<Array>}
 */
export const GetAllTagList = async () => {
  let result = []
  try {
    let res = await GetTagInfoList({})
    result = res.result || []
  } catch (e) {
    console.log(e.message)
  }
  return result
}
